<template>
  <el-container class="hotellist-main" id="main">
    <publicHeader @setCollapse="setCollapse" @getPermissions="getPermissions"></publicHeader>
    <div class="main-content">
      <publicMenu :isCollapse="isCollapse" :allPermissions="allPermissions"></publicMenu>
      <div class="content">
        <slot>
          <el-main>
            <div class="main" >
              <el-skeleton animated :loading="hotelLoading">
                <template slot="template">
                  <div class="hotel-info" style="margin-top: 0px;padding: 20px 1.5% 10px 1.5%;">
                    <div class="hotel-name"><el-skeleton-item variant="text" style="height: 35px; width: 35%;"/></div>
                    <el-skeleton-item variant="text" style="width: 10%;"/>
                    <div class="hotel-contact-info">
                      <el-skeleton-item variant="text" style="width: 40%;"/>
                    </div>
                    <div class="hotel-contact-info">
                      <el-skeleton-item variant="text" style="width: 20%;"/>
                    </div>
                    <div class="hotel-contact-info" style=" margin-bottom: 10px;">
                      <el-skeleton-item variant="text" style="width: 20%;"/>
                    </div>
                    <div style=" height: 12px;"></div>
                  </div>
                </template>
                <template>
                  <el-card :body-style="{ padding: '0px' }">
                    <div class="hotel-info" style="margin-top: 0px;padding: 20px 1.5% 10px 1.5%;">
                      <div>
                        <div class="pdfShow" v-if="orderDetail.platform === '3' && orderDetail.order_status === '3'">
                          <span @click="ShowPdf('Voucher')">Voucher</span>
                          <span @click="ShowPdf('Invoice')">Invoice</span>
                        </div>
                        <div class="hotel-name">{{hotelDetail.hotelname}}</div>
                      </div>
                      <div>
                        <span style="margin-right: 3px;" v-for="n in hotelDetail.star" :key="n">
                          <img style="width:15px;height:15px;" src="/static/img/star.png">
                        </span>
                        <span style="margin-left: -3px;" v-if="hotelDetail.star_decimal === 1">
                          <img style="width:15px;height:15px;" src="/static/img/star-decimal.png">
                        </span>
                      </div>
                      <div class="hotel-contact-info">
                        <div style="height: 100%;margin: auto 0px;"><img src="/static/img/account/location.png" alt=""></div>
                        <div style="margin-left:10px;">{{hotelDetail.hoteladdress}}</div>
                      </div>
                      <div class="hotel-contact-info" v-if="hotelDetail.tel !== ''">
                        <div style="height: 100%;margin: auto 0px;"><img src="/static/img/account/my-hotelphone.png" alt=""></div>
                        <div style="margin-left:10px;">{{hotelDetail.tel}}</div>
                      </div>
                      <div class="hotel-contact-info" v-if="hotelDetail.email !== ''">
                        <div style="height: 100%;margin: auto 0px;"><img src="/static/img/account/my-hotelemail.png" alt=""></div>
                        <div style="margin-left:10px;">{{hotelDetail.email}}</div>
                      </div>
                      <div style=" height: 12px;"></div>
                    </div>
                  </el-card>
                </template>
              </el-skeleton>
              <el-skeleton animated :loading="orderLoading">
                <template slot="template">
                  <div class="hotel-info">
                    <div class="first-line" style="height: 40px; line-height: 40px;">
                      <div class="title"><el-skeleton-item variant="text" style="width: 80%;"/></div>
                    </div>
                    <div class="line-info"></div>
                    <div class="order-item">
                      <div class="left-info"><el-skeleton-item variant="text" style="width: 80%;"/></div>
                      <div class="right-info"><el-skeleton-item variant="text" style="width: 20%;"/></div>
                    </div>
                    <div class="order-item">
                      <div class="left-info"><el-skeleton-item variant="text" style="width: 80%;"/></div>
                      <div class="right-info"><el-skeleton-item variant="text" style="width: 20%;"/></div>
                    </div>
                    <div class="order-item">
                      <div class="left-info"><el-skeleton-item variant="text" style="width: 80%;"/></div>
                      <div class="right-info"><el-skeleton-item variant="text" style="width: 20%;"/></div>
                    </div>
                    <div class="order-item">
                      <div class="left-info"><el-skeleton-item variant="text" style="width: 80%;"/></div>
                      <div class="right-info"><el-skeleton-item variant="text" style="width: 20%;"/></div>
                    </div>
                    <div class="order-item">
                      <div class="left-info"><el-skeleton-item variant="text" style="width: 80%;"/></div>
                      <div class="right-info"><el-skeleton-item variant="text" style="width: 20%;"/></div>
                    </div>
                    <div class="order-item">
                      <div class="left-info"><el-skeleton-item variant="text" style="width: 80%;"/></div>
                      <div class="right-info"><el-skeleton-item variant="text" style="width: 20%;"/></div>
                    </div>
                    <div class="order-item">
                      <div class="left-info"><el-skeleton-item variant="text" style="width: 80%;"/></div>
                      <div class="right-info"><el-skeleton-item variant="text" style="width: 20%;"/></div>
                    </div>
                    <div class="order-item">
                      <div class="left-info"><el-skeleton-item variant="text" style="width: 80%;"/></div>
                      <div class="right-info"><el-skeleton-item variant="text" style="width: 20%;"/></div>
                    </div>
                    <div class="order-item">
                      <div class="left-info"><el-skeleton-item variant="text" style="width: 80%;"/></div>
                      <div class="right-info"><el-skeleton-item variant="text" style="width: 20%;"/></div>
                    </div>
                    <div class="order-item">
                      <div class="left-info"><el-skeleton-item variant="text" style="width: 80%;"/></div>
                      <div class="right-info"><el-skeleton-item variant="text" style="width: 20%;"/></div>
                    </div>
                    <div class="order-item">
                      <div class="left-info"><el-skeleton-item variant="text" style="width: 80%;"/></div>
                      <div class="right-info"><el-skeleton-item variant="text" style="width: 20%;"/></div>
                    </div>
                    <div class="order-item">
                      <div class="left-info"><el-skeleton-item variant="text" style="width: 80%;"/></div>
                      <div class="right-info"><el-skeleton-item variant="text" style="width: 20%;"/></div>
                    </div>
                    <div class="order-item">
                      <div class="left-info"><el-skeleton-item variant="text" style="width: 80%;"/></div>
                      <div class="right-info"><el-skeleton-item variant="text" style="width: 20%;"/></div>
                    </div>
                    <div class="order-item">
                      <div class="left-info"><el-skeleton-item variant="text" style="width: 80%;"/></div>
                      <div class="right-info"><el-skeleton-item variant="text" style="width: 20%;"/></div>
                    </div>
                    <div class="order-item">
                      <div class="left-info"><el-skeleton-item variant="text" style="width: 80%;"/></div>
                      <div class="right-info"><el-skeleton-item variant="text" style="width: 20%;"/></div>
                    </div>
                  </div>
                </template>
                <template>
                  <el-card class="hotel-info" :body-style="{ padding: '0px' }">
                    <div class="first-line" style="height: 40px; line-height: 40px;">
                      <div class="title">Booking details</div>
                    </div>
                    <div class="line-info"></div>
                    <div class="order-item">
                      <div class="left-info">Booking reference&nbsp;</div>
                      <div class="right-info">{{orderDetail.orderno}}
                        <span>
                          <span class="tag-order-status tag-payment" v-if="['1', 1].includes(orderDetail.order_status)">{{$t('unpaid')}}</span>
                          <span class="tag-order-status tag-noconfirm" v-else-if="['2', 2].includes(orderDetail.order_status)">{{$t('pending')}}</span>
                          <span class="tag-order-status tag-confirm" v-else-if="['3', 3, '6', 6].includes(orderDetail.order_status)">{{$t('confirmed')}}</span>
                          <span class="tag-order-status tag-cancel" v-else-if="['4', 4].includes(orderDetail.order_status) && ['6', 6].includes(orderDetail.pay_status)">Cancelled (charges)</span>
                          <span class="tag-order-status tag-cancel" v-else-if="['5', 5].includes(orderDetail.order_status)">Rejected</span>
                          <span class="tag-order-status tag-cancel" v-else>{{$t('cancelled')}}</span>
                        </span>
                      </div>
                    </div>
                    <div class="order-item" v-if="orderDetail.hotel_orderno !== ''">
                      <div class="left-info">Hotel confirmation No</div>
                      <div class="right-info">{{orderDetail.hotel_orderno}}</div>
                    </div>
                    <div class="order-item">
                      <div class="left-info">Room type</div>
                      <div class="right-info">{{orderDetail.parent_room_en}}<a href="javascript:;" @click="showFacilities(orderDetail)" style="text-align: left; margin-left: 10px;">Facilities & Amenities</a></div>
                    </div>
                    <div class="order-item">
                      <div class="left-info">Check-in</div>
                      <div class="right-info">{{orderDetail.checkin_val}} （{{orderDetail.checkin_week_val}}）</div>
                    </div>
                    <div class="order-item">
                      <div class="left-info">Check-out</div>
                      <div class="right-info">{{orderDetail.checkout_val}} （{{orderDetail.checkout_week_val}}）</div>
                    </div>
                    <div class="order-item">
                      <div class="left-info">Night</div>
                      <div class="right-info">{{orderDetail.wan}}</div>
                    </div>
                    <div class="order-item">
                      <div class="left-info">Room</div>
                      <div class="right-info">{{orderDetail.roomcount}}</div>
                    </div>
                    <div class="order-item">
                      <div class="left-info">Guest</div>
                      <div class="right-info">{{orderDetail.adult_num}} <a v-if="orderDetail.adult_num === '1'">{{$t('adult')}}</a><a v-else>{{$t('adults')}}</a><span v-if="orderDetail.child_num !== '0'">, {{orderDetail.child_num}}<span v-if="orderDetail.child_num === '1'"> {{$t('child')}}</span><span v-else> {{$t('children')}}</span>{{orderDetail.childOld}}</span>
                      </div>
                    </div>
                    <div class="order-item">
                      <div class="left-info">Guest name</div>
                      <div class="right-info">{{orderDetail.adults_all}}</div>
                    </div>
                    <div class="order-item">
                      <div class="left-info">Email</div>
                      <div class="right-info">{{orderDetail.useremail}}</div>
                    </div>
                    <div class="order-item">
                      <div class="left-info">Bed type</div>
                      <div class="right-info">{{orderDetail.bedGroups[0].description}}</div>
                    </div>
                    <div class="order-item">
                      <div class="left-info">Breakfast</div>
                      <div class="right-info">
                        <span class="right-info" :class="{'green-text': orderDetail.breakfast === '1'}">{{orderDetail.breakfastStr}}</span>
                        <!-- <span class="green-text" v-if="orderDetail['breakfast'] === '1' || orderDetail['breakfast'] === 1">{{$t('bedBreakfast')}}</span>
                        <span v-else>{{$t('onlyBed')}}</span> -->
                      </div>
                    </div>
                    <div class="order-item">
                      <div class="left-info">Cancellation policy</div>
                      <!-- <div class="right-info">
                        <span class="infotd green-text" :class="{'orange-text': orderDetail.cancel === '0'}">{{orderDetail.cancel_txt}}</span>
                      </div> -->
                      <el-popover
                        placement="left"
                        width="350"
                        trigger="hover"
                        popper-class="nonFefundable"
                      >
                      <div class="cancel-policy">
                        <div class="title">Cancellation Policy</div>
                        <div class="content-wrapper">
                          <div v-for="(item, i) in orderDetail.cancelPenalties.list" :key="i" class="content-item">
                            <span class="circle" :style="{ border: '2px solid ' + setCancellationColor(item.type) }"></span>
                            <div class="text-content">
                              <div class="subtitle">{{ item.title }}</div>
                              <div class="description">{{ item.desc }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <span slot="reference" style="font-size: 14px;cursor:pointer;" :style="{ color: setCancellationColor(orderDetail.cancelPenalties.cancellation.type)}">{{orderDetail.cancelPenalties.cancellation.title}}</span>
                      </el-popover>
                    </div>
                    <div class="order-item">
                      <div class="left-info">Creation date</div>
                      <div class="right-info">{{orderDetail.create_date}}</div>
                    </div>
                    <div class="order-item" v-if="orderDetail.cancel_date !== ''">
                      <div class="left-info">Cancellation time</div>
                      <div class="right-info">{{orderDetail.cancel_date}}</div>
                    </div>
                    <div class="order-item">
                      <div class="left-info">Special request</div>
                      <div class="right-info">{{orderDetail.special_request}}</div>
                    </div>
                  </el-card>
                </template>
              </el-skeleton>
              <el-skeleton animated :loading="orderLoading">
                <template slot="template">
                  <div style="width: 100%; height: auto; display: table;">
                    <div class="left-price">
                      <div style="width: 100%; line-height:40px;">
                        <el-skeleton-item variant="text" style="width: 50%;"/>
                      </div>
                      <div class="line-info"></div>
                      <div class="price-info">
                        <div class="price-line">
                          <div class="price-info-left"><el-skeleton-item variant="text" style="width: 50%;"/></div>
                          <div class="price-info-right"><el-skeleton-item variant="text" style="width: 20%;"/></div>
                        </div>
                        <div class="price-line">
                          <div class="price-info-left"><el-skeleton-item variant="text" style="width: 50%;"/></div>
                          <div class="price-info-right"><el-skeleton-item variant="text" style="width: 20%;"/></div>
                        </div>
                      </div>
                      <div style="clear: both;"></div>
                      <div class="line-info-two"></div>
                      <div class="price-info">
                        <div class="price-line">
                          <div class="price-info-left"><el-skeleton-item variant="text" style="width: 50%;"/></div>
                          <div class="price-info-right"><el-skeleton-item variant="text" style="width: 20%;"/></div>
                        </div>
                      </div>
                    </div>
                    <div class="right-price">
                      <div style="width: 100%; line-height:40px;">
                        <el-skeleton-item variant="text" style="width: 50%;"/>
                      </div>
                      <div class="line-info"></div>
                      <div class="price-info">
                        <div class="price-line">
                          <div class="price-info-left"><el-skeleton-item variant="text" style="width: 50%;"/></div>
                          <div class="price-info-right"><el-skeleton-item variant="text" style="width: 20%;"/></div>
                        </div>
                        <div class="price-line">
                          <div class="price-info-left"><el-skeleton-item variant="text" style="width: 50%;"/></div>
                          <div class="price-info-right"><el-skeleton-item variant="text" style="width: 20%;"/></div>
                        </div>
                      </div>
                      <div style="clear: both;"></div>
                      <div class="line-info-two"></div>
                      <div class="price-info">
                        <div class="price-line">
                          <div class="price-info-left"><el-skeleton-item variant="text" style="width: 50%;"/></div>
                          <div class="price-info-right"><el-skeleton-item variant="text" style="width: 20%;"/></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </el-skeleton>
              <div class="price-hotel-info">
                <div class="price-hotel-info-left">
                  <div class="price-details-header">
                    <span class="package-hotel-name" style="font-weight: 650;">Price details</span>
                    <span class="package-tag" v-if="orderDetail.isPkg == 1">Package</span>
                  </div>
                  <div class="price-sections-container">
                    <!-- Pay today section -->
                    <div class="price-section">
                      <div class="section-title">Pay today</div>
                      <div class="price-list">
                        <div class="price-box">
                          <div class="price-item">
                            <span>{{orderDetail.roomcount}} {{$t('onOurSite')}}<span v-if="orderDetail.roomcount !=='1'">s</span> x {{orderDetail.wan}} {{$t('night')}}<span v-if="orderDetail.wan !=='1'">s</span></span>
                            <span>{{orderDetail.unitprice_all}}</span>
                          </div>
                          <div class="price-item">
                            <span>Taxes & fees
                              <el-tooltip
                              content="The taxes are tax recovery charges paid to vendors (e.g., hotels); for details, please see our Terms of Use . Service fees are retained as compensation in servicing your booking and may include fees charged by vendors."
                              placement="top"
                              effect="light"
                              >
                              <span style="cursor: pointer;color: #000000D9;margin-left: 6px;">ⓘ</span>
                            </el-tooltip>
                          </span>
                          <span>{{orderDetail.tax_new}}</span>
                        </div>
                        <div  class="price-item" v-if="orderDetail.transaction_fee !== '' && orderDetail.transaction_fee !== 0 && orderDetail.transaction_fee !== '0' && orderDetail.transaction_fee !== '0.00'">
                          <span>Transaction fee</span>
                          <span>{{orderDetail.currency}}{{orderDetail.transaction_fee}}</span>
                        </div>
                        <div class="price-item green-text" v-if="orderDetail.discount_price !== '' && orderDetail.discount_price !== 0 && orderDetail.discount_price !== '0' && orderDetail.discount_price !== '0.00' && orderDetail.discount_price !== 0.00">
                          <span>Coupon</span>
                          <span>
                            {{orderDetail.currency}}{{orderDetail.discount_price}}
                          </span>
                        </div>
                      </div>

                      <div class="divider"></div>
                      <div class="price-item total">
                        <span>Total</span>
                        <span>{{orderDetail.payprice_new}}</span>
                      </div>
                    </div>
                  </div>

                  <!-- Due at property section -->
                  <div class="price-section">
                    <div class="section-title">Due at property</div>
                    <div class="price-list">
                      <div class="price-box">
                        <div class="price-item" v-if="orderDetail.mandatoryFee !== ''">
                          <span>{{$t('mandatoryFee')}}<a class="avgprice"> ({{$t('payableAtProperty')}})</a></span>
                          <span>{{orderDetail.mandatoryFee}}</span>
                        </div>
                        <div class="price-item" v-if="orderDetail.mandatoryTax !== ''">
                          <span>{{$t('mandatoryTax')}}<a class="avgprice"> ({{$t('payableAtProperty')}})</a></span>
                          <span>{{orderDetail.mandatoryTax}}</span>
                        </div>
                        <div class="price-item" v-if="orderDetail.resortFee !== ''">
                          <span>{{$t('resortFee')}}<a class="avgprice"> ({{$t('payableAtProperty')}})</a></span>
                          <span>{{orderDetail.resortFee}}</span>
                        </div>
                        <div class="price-item" v-if="orderDetail.cityFee !== ''">
                          <span>{{$t('cityTaxFee')}}<a class="avgprice"> ({{$t('payableAtProperty')}})</a></span>
                          <span>{{orderDetail.cityFee}}</span>
                        </div>
                        <div class="price-item" v-if="orderDetail.destinationFee !== ''">
                          <span>{{$t('destinationFee')}}<a class="avgprice"> ({{$t('payableAtProperty')}})</a></span>
                          <span>{{orderDetail.destinationFee}}</span>
                        </div>
                        <div class="price-item" v-if="orderDetail.serviceFee !== ''">
                          <span>{{$t('serviceFee')}}<a class="avgprice"> ({{$t('payableAtProperty')}})</a></span>
                          <span>{{orderDetail.serviceFee}}</span>
                        </div>
                        <div class="price-item" v-if="orderDetail.cleaningFee !== ''">
                          <span>{{$t('cleaningFee')}}<a class="avgprice"> ({{$t('payableAtProperty')}})</a></span>
                          <span>{{orderDetail.cleaningFee}}</span>
                        </div>
                        <div class="price-item" v-if="orderDetail.administrativeFee !== ''">
                          <span>{{$t('administrativeFee')}}<a class="avgprice"> ({{$t('payableAtProperty')}})</a></span>
                          <span>{{orderDetail.administrativeFee}}</span>
                        </div>
                      </div>
                      <div class="divider"></div>
                      <div class="price-item total">
                        <span>Total</span>
                        <span>{{orderDetail.surcharge_money_new}}</span>
                      </div>
                    </div>
                  </div>
                  </div>

                  <div class="total-price">
                    <span>Total price</span>
                    <span style="margin-left: 4px;">{{orderDetail.totalprice_new}}</span>
                  </div>
                </div>
                <div class="price-hotel-info-right">
                  <div class="price-details-header">
                    <span class="package-hotel-name" v-if="['4', 4, '5', 5].includes(orderDetail.order_status)" style="font-weight: 650;">Payment and refund information</span>
                    <span class="package-hotel-name" v-else style="font-weight: 650;">Payment details</span>
                  </div>
                  <div class="price-sections-container">
                    <!-- Pay today section -->
                    <div class="price-section">
                      <div class="price-list">
                        <div class="price-box">
                          <div class="price-item">
                            <span>Payment methods</span>
                            <span>
                              <span v-if="orderDetail.cardtype === '5' || orderDetail.cardtype === 5"><img style="vertical-align: middle;height:25px; margin-right: 5px;" src="/static/img/order/balance.png" />Credit</span>
                              <span v-else-if="orderDetail.cardtype === '6' || orderDetail.cardtype === 6"><img style="vertical-align: middle;height:25px;" src="https://res.roompai.com/static/img/order/paypal.png" /></span>
                              <span v-else-if="['8', 8].includes(orderDetail.cardtype)"><img style="vertical-align: middle;height:25px; margin-right: 5px;" src="/static/img/order/pingpong.png" />Pay by Card</span>
                              <span v-else-if="['10', 10].includes(orderDetail.cardtype)"><img style="vertical-align: middle;height:25px; margin-right: 5px;" src="/static/img/order/Points.png" />Points</span>
                            </span>
                          </div>
                          <div class="price-item" v-if="['4', 4, '5', 5].includes(orderDetail.order_status)">
                            <span>Payment amounts</span>
                            <span>
                              <span v-if="orderDetail.surcharge_money !== ''">{{orderDetail.payprice_new}}</span>
                              <span v-else>{{orderDetail.totalprice_new}}</span>
                            </span>
                          </div>
                          <div  class="price-item" v-if="['4', 4, '5', 5].includes(orderDetail.order_status)">
                            <span>Cancellation charges</span>
                            <span>{{orderDetail.cancel_price}}</span>
                          </div>
                      </div>

                      <div class="divider"></div>
                      <div class="price-item total" v-if="['4', 4, '5', 5].includes(orderDetail.order_status)">
                        <span>Refund</span>
                        <span>{{orderDetail.refund_price}}</span>
                      </div>
                      <div class="price-item total" v-else>
                        <span>Payment amounts</span>
                        <span>
                          <span v-if="orderDetail.surcharge_money !== ''">{{orderDetail.payprice_new}}</span>
                          <span v-else>{{orderDetail.totalprice_new}}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                  </div>

                  <div class="total-price">
                    <span>Total price</span>
                    <span style="margin-left: 4px;">{{orderDetail.totalprice_new}}</span>
                  </div>
                </div>
              </div>
              <!--积分信息模块 开始-->
              <div class="points-hotel-info" style="padding: 10px 1.5%;" v-if="orderDetail.pointsList && orderDetail.pointsList.length > 0 &&
                      orderDetail.pointsList.some(item => Number(item.pointsAmount) !== 0)">
                <div class="points-hotel-name" style="font-weight: 650;">{{$t('pointsInformation')}}</div>
                <div style="border-bottom: 1.5px solid rgba(83, 102, 163, 1);"></div>
                <div class="order-info" style="width: 940px;margin-top: 10px;">
                  <div v-for="(item, index) in orderDetail.pointsList" :key="index">
                    <div class="quarter-row"  v-if="Number(item.pointsAmount) !== 0">
                      <div class="quarter-col">{{item.event}}</div>
                      <div class="quarter-col"><span :style="{ color: item.pointsSign === '+' ? '#2F7000' : '#E80000' }">{{ item.pointsSign }}{{Number(item.pointsAmount).toLocaleString()}}</span> {{item.pointsType}}</div>
                      <div class="quarter-col">{{item.date}}</div>
                    </div>
                  </div>
                  <div class="points-txt">{{$t('pointsTxt')}}</div>
                </div>
              </div>
              <!--积分信息模块 结束-->
              <!--订房须知-->
              <div class="container">
                <h1>Hotel Policies</h1>
                <div class="policy-columns">
                  <div class="policy-column">

                    <div class="policy-module" v-if="hotelPolicyData.checkin_begin_time">
                      <h2>Check In</h2>
                      <div>Check in time: {{hotelPolicyData.checkin_begin_time}} - {{hotelPolicyData.checkin_end_time}}</div>
                    </div>

                    <div class="policy-module" v-if="hotelPolicyData.checkout_time_en">
                      <h2>Check out</h2>
                      <div>Check out time: {{hotelPolicyData.checkout_time_en}}</div>
                    </div>

                    <div class="policy-module" v-if="hotelPolicyData.hotel_checkin_instructions_en">
                      <h2>Instructions</h2>
                      <div class="policy-content" v-html="hotelPolicyData.hotel_checkin_instructions_en"></div>
                    </div>

                    <div class="policy-module" v-if="hotelPolicyData.special_instructions_en">
                      <h2>Special Instructions</h2>
                      <div class="policy-content" v-html="hotelPolicyData.special_instructions_en"></div>
                    </div>

                    <div class="policy-module" v-if="hotelPolicyData.fees_mandatory_en">
                      <h2>Fees</h2>
                      <div class="policy-content" v-html="hotelPolicyData.fees_mandatory_en"></div>
                    </div>

                    <div class="policy-module" v-if="hotelPolicyData.other_policies_en">
                      <h2>Policies</h2>
                      <div class="policy-content" v-html="hotelPolicyData.other_policies_en"></div>
                    </div>

                  </div>
                </div>
              </div>
              <div class="hotel-info" v-if="orderDetail.surcharge_txt_en !== '' && orderDetail.surcharge_txt_en !== null">
                <div style="width: 100%; height: 40px; line-height:40px;">
                  <div class="title-left">Booking notice</div>
                </div>
                <div class="line-info"></div>
                <div>
                  <div class="room-order-tips-info" v-html="orderDetail.surcharge_txt_en"></div>
                </div>
              </div>
              <!-- 按钮  -->
              <div class="button-info">
                <!-- 返回按钮 -->
                <el-button type="button" class="float-none booknow_button" @click="goBack">Back</el-button>
                <!-- 取消按钮 -->
                <button class="float-none white_button" @click="openCancelDia" v-if="orderDetail.doCancel">Cancel booking</button>
                <!-- 不可操作取消按钮 -->
                <button type="button" class="float-none display-button" v-else>Cancel booking</button>
              </div>
              <div class="hotel-info" v-if="logDetail !== ''">
                <div class="first-line" style="height: 40px; line-height: 40px;">
                  <div class="title">Booking notes</div>
                </div>
                <div class="line-info"></div>
                <div class="notes-item" v-for="(value, key) in logDetail" :key="key" :class="{'notes-margin': key === 1 || key === '1'}">
                  <div style=" width: 15%;">{{value.time}}&nbsp;</div>
                  <div style=" width: 12%;">Operater:&nbsp; {{value.user}}&nbsp;</div>
                  <div style=" width: 73%; line-height: 25px;">{{value.content}}</div>
                </div>
              </div>
            </div>
            <!--取消订单-->
            <el-dialog class="open-dia" title="" :close-on-click-modal="showClo" :close-on-press-escape="showClo" :show-close="showClo" :visible.sync="openCancel" :width="diaWidth">
              <div slot="title" style="font-size: 20px; font-weight: 650;color:rgba(83, 102, 163, 1);">{{$t('cancel')}}</div>
              <div class="dia-content">
                <div style="overflow-wrap: break-word; word-wrap: break-word; -ms-word-break: break-all; word-break: break-all; word-break: break-word; -ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto; hyphens: auto;">{{$t('nowCancelRefund')}} <span style="color:red;">{{refundDetail.cancelprice_val}}</span>.</div>
                <div style="font-weight:600;margin-bottom: 4px;margin-top: 20px;">{{$t('orderPrice')}}</div>
                <div style="font-size: 14.88px;">{{refundDetail.totalprice_val}}</div>
                <div style="font-weight:400;color: #999999;font-size: 13px;margin-top: 4px;" v-if="refundDetail.used_points_amount && refundDetail.used_points_amount !== '0'">{{refundDetail.used_points_amount}} Points</div>
              </div>
              <div class="dia-content">
                <div style="font-weight:600;margin-bottom: 4px;">{{$t('cancelPrice')}}</div>
                <div style="font-size: 14.88px;color: #E80000;">{{refundDetail.cancelprice_val}}</div>
                <div style="font-weight:400;color: #E80000;font-size: 13px;margin-top: 4px;" v-if="refundDetail.cancel_points_fee_amount && refundDetail.cancel_points_fee_amount !== '0'">{{refundDetail.cancel_points_fee_amount}} Points</div>
              </div>
              <div style="font-weight:600;padding: 20px 5% 0px 5%;">
                <div style="margin-bottom: 4px;">{{$t('refundPrice')}}</div>
                <div style="color: #2F7000;font-size: 15px;">{{refundDetail.refundprice_val}}</div>
                <div style="font-weight:400;color: #2F7000;font-size: 13px;margin-top: 4px;" v-if="refundDetail.refund_points_amount && refundDetail.refund_points_amount !== '0'">{{refundDetail.refund_points_amount}} Points</div>
              </div>
              <div slot="footer" class="dialog-footer">
                <el-button class="booknow_button" style="width: auto;float: left;" type="primary" @click="cancelContinue">{{$t('confirmCancellation')}}</el-button>
                <el-button class="white_button" style="width: auto;" @click="openCancel = false">{{$t('keepMyBooking')}}</el-button>
              </div>
            </el-dialog>
            <!--继续取消-->
            <el-dialog class="open-dia" title="" :close-on-click-modal="showClo" :close-on-press-escape="showClo" :show-close="showClo" :visible.sync="cancelContinueDia" :width="diaWidth">
              <div slot="title" style="font-size: 20px; font-weight: 650;color:rgba(83, 102, 163, 1);">{{$t('cancel')}}</div>
              <div class="dia-content">
                <div style="overflow-wrap: break-word; word-wrap: break-word; -ms-word-break: break-all; word-break: break-all; word-break: break-word; -ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto; hyphens: auto;">{{$t('canNotCancelLeft')}} <span style="color:red;">{{refundDetail.cancelprice_val}}</span> {{$t('canNotCancelRight')}}</div>
                <div style="margin-top: 30px;">{{$t('isContinueCancel')}}</div>
              </div>
              <div slot="footer" class="dialog-footer">
                <el-button class="white_button" style="width:auto; margin-right: 20px;" @click="cancelContinueDia = false">{{$t('close')}}</el-button>
                <el-button class="booknow_button" style="width: auto;" type="primary" @click="doCancel">{{$t('continueCancel')}}</el-button>
              </div>
            </el-dialog>
            <!--取消订单成功-可退款-->
            <el-dialog class="dia-success" title="" :close-on-press-escape="showClo" :show-close="showClo" @close="refreshUrl" :visible.sync="cancelSuccess" :width="diaWidth">
              <div style="text-align:center;">
                <div class="order-status-img" style="width:70px;height:70px;background:rgba(83, 102, 163, 1);border-radius: 50%; margin:0 auto;">
                    <img style="width:30px; height:30px;margin: 20px;" src="https://res.roompai.com/static/img/account/my-payment-yes.png">
                </div>
                <div style="overflow-wrap: break-word; word-wrap: break-word; -ms-word-break: break-all; word-break: break-all; word-break: break-word; -ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto; hyphens: auto;">
                  <div style="margin:25px 0px; font-size: 18px;">{{$t('orderCancelSuccess')}}</div>
                  <div class="cancelmsg-text" style="text-align:left;padding:1 20px 20px 20px" v-if="payMethod !== 'credit'">{{$t('yourCardOrAccountShouldReceiveRefundAmountLeft')}}&nbsp;{{refundDetail.refundprice_val}}&nbsp;{{$t('yourCardOrAccountShouldReceiveRefundAmountRight')}}</div>
                  <div class="cancelmsg-text" style="text-align:left;padding:1 20px 20px 20px" v-else>We will initiate {{refundDetail.refundprice_val}} to your credit account. If you have any additional questions about your refund, please contact our customer service team.</div>
                </div>
              </div>
            </el-dialog>
            <!--取消订单成功-不可退款-->
            <el-dialog class="dia-success" title="" :close-on-press-escape="showClo" :show-close="showClo" @close="refreshUrl" :visible.sync="cancelSuccessNoRefund" :width="diaWidth">
              <div style="text-align:center;">
                <div class="order-status-img" style="width:70px;height:70px;background:rgba(83, 102, 163, 1);border-radius: 50%; margin:0 auto;">
                    <img style="width:30px; height:30px;margin: 20px;" src="https://res.roompai.com/static/img/account/my-payment-yes.png">
                </div>
                <div style="overflow-wrap: break-word; word-wrap: break-word; -ms-word-break: break-all; word-break: break-all; word-break: break-word; -ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto; hyphens: auto;">
                  <div style="margin:25px 0px; font-size: 18px;">
                    {{$t('orderCancelSuccess')}}
                  </div>
                  <div class="cancelmsg-text"  style="text-align: left;padding:0 20px 20px 20px">Since this booking is non refundable now, there will be no refund of it. {{$t('norefundContactUs')}}</div>
                </div>
              </div>
            </el-dialog>
            <!--取消订单失败-->
            <el-dialog class="dia-success" title="" :close-on-press-escape="showClo" :show-close="showClo" @close="refreshUrl" :visible.sync="cancelFailed" :width="diaWidth">
                <div style="text-align:center;">
                  <div class="order-status-img" style="width:70px;height:70px;background:red;border-radius: 50%; margin:0 auto;">
                      <img style="width:40px; height:40px;margin: 15px;" src="https://res.roompai.com/static/img/account/my-error.png">
                  </div>
                  <div stype="overflow-wrap: break-word; word-wrap: break-word; -ms-word-break: break-all; word-break: break-all; word-break: break-word; -ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto; hyphens: auto;">
                    <div style="margin:25px 0px; font-size: 18px;">
                      {{$t('orderCancelfaild')}}
                    </div>
                    <div class="cancelmsg-text" style="overflow-wrap: break-word; word-wrap: break-word; -ms-word-break: break-all; word-break: break-all; word-break: break-word; -ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto; hyphens: auto;">
                      {{$t('contactCustomer')}}
                    </div>
                    <div class="cancelmsg-text">
                      {{$t('contactEmail')}} customer-support@HiBeds.com
                    </div>
                    <!-- <div class="cancelmsg-text">
                      {{$t('internationalCall')}}: {{phoneInternal}}
                    </div> -->
                  </div>
                </div>
            </el-dialog>
          </el-main>
        </slot>
        <publicFooter :source="source"></publicFooter>
        <OrderPdf :visible.sync="pdfVisible" :type="pdfType" @updateVisible="updatePdfPreviewVisible"></OrderPdf>
      </div>
    </div>
    <el-dialog
      title="Facilities & Amenities"
      :visible.sync="facilitiesDialogVisible"
      width="30%"
      custom-class="facilities-dialog"
      >
      <div class="facilities-divider"></div>
      <ul class="facilities-list">
        <li v-for="item in amenities" :key="item.name">
          <span class="arrow-icon">►</span>
          <span>{{ item.name }}</span>
        </li>
        <li v-for="item in promotions" :key="item.id">
          <span class="arrow-icon">►</span>
          <span>{{ item.description }}</span>
        </li>
      </ul>
    </el-dialog>
  </el-container>
  </template>

<script>
import { getTripTime, getTripDetail, getCancelPriceDetail, orderCancel, downloadTrip } from '@/request/order.js'
import { hotelPolicyNew } from '@/request/hotel.js'
import publicFooter from '@/components/public/publicFooter'
import publicHeader from '@/components/public/publicHeader'
import publicMenu from '@/components/public/publicMenu'
import OrderPdf from '@/components/account/module/OrderPdf'
export default {
  name: 'tripDetail',
  components: {
    publicFooter,
    publicHeader,
    publicMenu,
    OrderPdf
  },
  data () {
    return {
      curPageData: 'TripDetail',
      orderno: '',
      cancelShow: false,
      confirmShow: false,
      noConfirmShow: false,
      paymentShow: false,
      childPaymentShow: false,
      confirmMessShow: true,
      openCancel: false,
      cancelContinueDia: false,
      showClo: false,
      cancelSuccess: false,
      cancelSuccessNoRefund: false,
      cancelFailed: false,
      grayColor: false,
      floatRight: false,
      cancelMessShow: false,
      reportShow: false,
      reportNoShow: true,
      minute: '',
      second: '',
      remainTime: 0,
      minuteString: '',
      secondString: '',
      currency: this.common.currencySet(this),
      language: this.common.languageSet(this),
      hotelDetail: [],
      orderDetail: {'surcharge_txt_en': ''},
      refundDetail: [],
      logDetail: '',
      is_cancel: false,
      orderstatus: '',
      refreshDetailTime: 5,
      exportPDFtitle: this.$route.query.orderno,
      tripPdfInformation: {},
      currencyShow: false, // 币种是否显示
      ismobile: false,
      taxDia: false,
      cancelDia: false,
      taxShowClose: false,
      diaWidth: '500px',
      selectOptionWidth: '460',
      msgWidth: document.documentElement.clientWidth * 0.95 - 70,
      source: 'roompai',
      sendPdfEmail: false,
      sendEmail: '',
      check: false,
      clickCancel: true,
      bookingNoticeShow: false,
      specialInstructionsShow: false,
      cancelText: '',
      cancelDiaShow: false,
      cancelShowClose: false,
      customerEmail: '',
      phoneInternal: '',
      phoneExternal: '',
      TemporaryOrder: false,
      hotelLoading: true,
      orderLoading: true,
      priceLoading: true,
      noticeShow: false,
      isCollapse: this.common.collapseSet(),
      contentWidth: document.body.clientWidth - 74,
      payMethod: '',
      priceHeight: '',
      priceRightHeight: 40,
      totalHeight: 40,
      allPermissions: {'email': '', 'phone_internal': '', 'phone_external': ''},
      pdfVisible: false,
      pdfType: '',
      hotelPolicyData: {},
      facilitiesDialogVisible: false,
      promotions: [],
      amenities: []
    }
  },
  mounted () {
    this.getTime() // 调用定时器
    if (this.orderstatus === 3 || this.orderstatus === '3') {
      this.getOverTime() // 调用获取订单状态定时器
    }
    this.language = this.common.languageSet(this)
    this.currency = this.common.currencySet(this)
    if (document.documentElement.clientWidth < 1001) {
      this.ismobile = true
      this.reportNoShow = false
      this.reportShow = false
      this.diaWidth = '95%'
    } else {
      this.ismobile = false
      this.diaWidth = '500px'
    }
    var source = this.$route.query.source
    if (source !== '' && source !== undefined && source !== null) {
      this.source = source
    }
    if (this.$route.query.orderno.startsWith('Temporary-')) {
      this.TemporaryOrder = true
      this.curPageData = 'TripDetailTemporary'
      console.log(this.curPageData)
    }
    this.getDetail()
  },
  watch: {
    language: function (newCur, oldCur) {
      this.getDetail()
    }
  },
  computed: {
    formattedSpecialInstructions () {
      if (!this.hotelPolicyData.special_instructions_en) {
        return ''
      }
      const sentences = this.hotelPolicyData.special_instructions_en.split('.').filter(sentence => sentence.trim() !== '')
      const listItems = sentences.map(sentence => `<li>${sentence.trim()}.</li>`).join('')
      return `<ul>${listItems}</ul>`
    }
  },
  methods: {
    showFacilities (orderData) {
      this.amenities = orderData.amenities
      this.promotions = orderData.promotions
      this.facilitiesDialogVisible = true
    },
    setCancellationColor (value) {
      if (value === '1' || value === 1) {
        return '#007f61'
      } else if (value === '2' || value === 2) {
        return '#d99c00'
      } else {
        return '#cc0000'
      }
    },
    updatePdfPreviewVisible (value) {
      this.pdfVisible = value
    },
    ShowPdf (type) {
      this.pdfType = type
      this.pdfVisible = true
    },
    getPermissions (value) {
      this.allPermissions = value
    },
    setCollapse (value) {
      this.isCollapse = value
      if (value === false) {
        this.contentWidth = document.body.clientWidth - 260
      } else {
        this.contentWidth = document.body.clientWidth - 74
      }
    },
    setOptionWidth (event) {
      if (this.ismobile === true) {
        this.selectOptionWidth = event.view.innerWidth * 0.95 - 40
      }
    },
    hotelLanguage (language) {
      this.language = language
    },
    refreshUrl () {
      this.getDetail()
    },
    getTime () {
      var orderno = this.$route.query.orderno
      var time = parseInt(new Date().getTime() / 1000)
      // 验证verify
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {
        'orderno': orderno,
        'time': time,
        'token': token,
        'sessionid': sessionid
      }
      var data = this.common.encryptionData(dataJson, this)
      getTripTime(data).then(res => {
        console.log(res)
        var time = parseInt(new Date().getTime() / 1000)
        if (res.flag === '200') {
          var orderstatus = res.data.order_status
          this.orderstatus = orderstatus
          var createtime = res.data.create_time
          var paytime = res.data.pay_time
          var waittime = parseInt(res.data.wait_time)
          if (orderstatus === '1') {
            this.remainTime = parseInt(createtime) + 300 - time
          } else {
            this.remainTime = parseInt(paytime) + waittime - time
          }
        } else {
          this.remainTime = 1800
        }
      })
      setInterval(() => {
        if (this.remainTime > 0) {
          this.remainTime -= 1
          this.countDown()
        } else {
          this.minuteString = '00'
          this.secondString = '00'
          this.check = true
        }
      }, 1000)
    },
    getOverTime () {
      var refreshtime = 700
      setInterval(() => {
        if (refreshtime > 0) {
          refreshtime -= 1
          if (refreshtime % 5 === 0) {
            this.getTripStatus()
          }
        }
      }, 1000)
    },
    goBack () {
      this.$router.push({name: 'MyTrip', query: {'source': this.source}})
    },
    getDetail () {
      this.common.stopScroll()
      var orderno = this.$route.query.orderno
      if (orderno === undefined) {
        this.detail = []
        return false
      }
      var time = parseInt(new Date().getTime() / 1000)
      // 验证verify
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {
        'orderno': orderno,
        'time': time,
        'currency': this.currency,
        'language': this.language,
        'token': token,
        'sessionid': sessionid
      }
      var data = this.common.encryptionData(dataJson, this)
      getTripDetail(data).then(res => {
        if (res.flag === '110') {
          this.$router.push({name: 'HotelList', query: {'source': this.source}})
        } else if (res.flag === '001') {
          if (this.source !== '') {
            this.$router.push({name: 'login', query: {'source': this.source}})
          } else {
            this.$router.push({name: 'login'})
          }
        } else if (res.flag === '200') {
          this.hotelDetail = res.data.hotelDetail
          this.orderDetail = res.data.orderDetail
          this.logDetail = res.data.logDetail
          this.cancelText = this.orderDetail.cancel_txt_all
          this.check = this.orderDetail.check
          this.payMethod = this.orderDetail.pay_way
          if ((this.language === 'zh' && this.orderDetail.surcharge_txt_zh !== '') || (this.language === 'en' && this.orderDetail.surcharge_txt_en !== '')) {
            this.noticeShow = true
          } else {
            this.noticeShow = false
          }
          if (this.orderDetail.surcharge_money !== '') {
            this.totalHeight = 120
          }
          if (res.data.orderDetail.child_order_status === '1' || res.data.orderDetail.child_order_status === 1) {
            this.childPaymentShow = true
            this.paymentShow = false
            this.cancelShow = false
            this.confirmShow = false
            this.noConfirmShow = false
          } else {
            this.childPaymentShow = false
            if (res.data.orderDetail.order_status === '1') {
              this.paymentShow = true
              this.cancelShow = false
              this.confirmShow = false
              this.noConfirmShow = false
              this.floatRight = true
            } else if (res.data.orderDetail.order_status === '2') {
              this.paymentShow = false
              this.cancelShow = false
              this.confirmShow = false
              this.noConfirmShow = true
            } else if (res.data.orderDetail.order_status === '3' || res.data.orderDetail.order_status === '6') {
              this.paymentShow = false
              this.cancelShow = false
              this.confirmShow = true
              this.noConfirmShow = false
              if (res.data.orderDetail.cancel_status === '1') {
                this.grayColor = true
              }
            } else {
              this.paymentShow = false
              this.cancelShow = true
              this.confirmShow = false
              this.noConfirmShow = false
              this.confirmMessShow = false
              this.cancelMessShow = true
            }
          }
          if (res.data.orderDetail.order_status === '1') {
            this.floatRight = true
          } else {
            this.floatRight = false
          }
          this.tripPdfInformation = {'Booking reference': this.orderDetail.orderno, 'Creation date': this.orderDetail.create_time_val, 'Hotel': this.hotelDetail.hotelname, 'Address': this.hotelDetail.hoteladdress, 'Property Contact Number': this.hotelDetail.tel, 'Lead guest': this.orderDetail.leadguest}
          if (this.ismobile === false) {
            this.reportShow = true
          }
          this.reportNoShow = false

          var policyDataJson = {'hotelid': this.hotelDetail.hotelid, 'operation': 'hotelPolicyNew', 'time': time, 'sessionid': sessionid}
          var policyData = this.common.encryptionData(policyDataJson, this)
          hotelPolicyNew(policyData).then(res => {
            this.hotelPolicyData = res.data
          })
        } else {
          this.$router.push({name: 'MyTrip', query: {'source': this.source}})
        }
        this.hotelLoading = false
        this.orderLoading = false
        this.priceLoading = false
        var that = this
        this.$nextTick(() => {
          let leftHeight = that.$refs['divName'].clientHeight
          let rightHeight = that.$refs['divRightName'].clientHeight
          if (leftHeight > rightHeight) {
            this.priceHeight = leftHeight
          } else if (leftHeight <= rightHeight) {
            this.priceHeight = rightHeight
          }
          if (['4', 4, '5', 5].includes(this.orderDetail.order_status)) {
            this.priceRightHeight = this.priceHeight / 3
          } else {
            this.priceRightHeight = this.priceHeight / 2
          }
        })
        this.common.canScroll()
      })
    },
    downloadPdf () {
      var orderno = this.$route.query.orderno
      var time = parseInt(new Date().getTime() / 1000)
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {
        'orderno': orderno,
        'time': time,
        'token': token,
        'sessionid': sessionid
      }
      var data = this.common.encryptionData(dataJson, this)
      console.log(data)
      downloadTrip(data).then(res => {
        console.log(res)
        if (res.flag === '001') {
          let locationHref = window.document.location.href
          sessionStorage.setItem('LoginWebsiteAddress', locationHref)
          if (this.source !== '') {
            this.$router.push({name: 'login', query: {'source': this.source}})
          } else {
            this.$router.push({name: 'login'})
          }
        } else if (res.flag === '200') {
          this.sendPdfEmail = true
          this.sendEmail = res.data.email
        }
      })
      // let data = Object.assign({}, this.$refs)
      // html2pdf(data.pdfDom, {
      //   margin: 1,
      //   filename: this.exportPDFtitle + '.pdf',
      //   image: {
      //     type: 'jpeg',
      //     quality: 1
      //   },
      //   html2canvas: {
      //     scale: 2,
      //     allowTaint: false,
      //     useCORS: true
      //   },
      //   jsPDF: {
      //     unit: 'pt',
      //     format: 'a4',
      //     orientation: 'landscape'
      //   }
      // })
    },
    openCancelDia () {
      if (this.grayColor === true) {
        return false
      }
      // 获取扣款和退款金额
      var orderno = this.$route.query.orderno
      if (orderno === undefined) {
        this.detail = []
        return false
      }
      var time = parseInt(new Date().getTime() / 1000)
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {
        'orderno': orderno,
        'time': time,
        'currency': this.currency,
        'orderstatus': this.orderstatus,
        'language': this.language,
        'token': token,
        'sessionid': sessionid
      }
      var data = this.common.encryptionData(dataJson, this)
      console.log(data)
      getCancelPriceDetail(data).then(res => {
        console.log(res)
        if (res.flag === '001') {
          this.$router.push({name: 'login'})
        } else if (res.flag === '200') {
          this.refundDetail = res.data.detail
          this.is_cancel = res.data.detail.is_cancel
          this.openCancel = true
        } else {
          this.$message({type: 'error', message: res.msg})
          if (res.flag === '110') {
            this.$router.push({name: 'login'})
          }
        }
      })
    },
    cancelContinue () {
      if (this.is_cancel === false) {
        this.openCancel = false
        this.cancelContinueDia = true
      } else {
        this.checkCancelStatus()
      }
    },
    checkCancelStatus () {
      var orderno = this.$route.query.orderno
      if (orderno === undefined) {
        this.detail = []
        return false
      }
      let token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }
      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)
      // 如果可取消，则再次确认是否可取消，如果不可取消，则弹框
      if (this.is_cancel === true || this.orderstatus === 2 || this.orderstatus === '2') {
        var dataJson = {
          'orderno': orderno,
          'time': time,
          'currency': this.currency,
          'language': this.language,
          'orderstatus': this.orderstatus,
          'token': token,
          'sessionid': sessionid
        }
        var data = this.common.encryptionData(dataJson, this)
        getCancelPriceDetail(data).then(res => {
          if (res.flag === '001') {
            this.$router.push({name: 'login'})
          } else if (res.flag === '200') {
            if (res.data.detail.is_cancel === false) {
              this.openCancel = false
              this.cancelContinueDia = true
              this.refundDetail = res.data.detail
              this.is_cancel = res.data.detail.is_cancel
            } else {
              this.doCancel()
            }
          } else {
            this.$message({type: 'error', message: res.msg})
            if (res.flag === '110') {
              this.$router.push({name: 'login'})
            }
          }
        })
      }
    },
    doCancel () {
      if (this.clickCancel === false) {
        return false
      }
      this.clickCancel = false
      var orderno = this.$route.query.orderno
      if (orderno === undefined) {
        this.detail = []
        return false
      }
      var time = parseInt(new Date().getTime() / 1000)
      let token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {
        'orderno': orderno,
        'cancelprice': this.refundDetail.cancelprice,
        'refundprice': this.refundDetail.refundprice,
        'orderstatus': this.orderstatus,
        'time': time,
        'token': token,
        'sessionid': sessionid
      }
      var data = this.common.encryptionData(dataJson, this)
      orderCancel(data).then(res => {
        this.clickCancel = true
        if (res.flag === '001') {
          if (this.source !== '') {
            this.$router.push({name: 'login', query: {'source': this.source}})
          } else {
            this.$router.push({name: 'login'})
          }
        } else if (res.flag === '200') {
          // 取消订单成功
          this.openCancel = false
          this.cancelContinueDia = false
          if (res.data.is_cancel === false) {
            this.cancelSuccessNoRefund = true
          } else {
            this.cancelSuccess = true
          }
        } else {
          // 取消订单失败
          this.openCancel = false
          this.cancelContinueDia = false
          this.cancelFailed = true
          this.orderDetail.doCancel = false
        }
      })
    },
    countDown () {
      let m = parseInt(this.remainTime / 60 % 60)
      let s = parseInt(this.remainTime % 60)
      if (m === 0 && s === 0) {
        this.getDetail()
      }
      this.minuteString = this.formatNum(m)
      this.secondString = this.formatNum(s)
    },
    getTripStatus () {
      var orderno = this.$route.query.orderno
      var time = parseInt(new Date().getTime() / 1000)
      var token = localStorage.getItem('token')
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {
        'orderno': orderno,
        'time': time,
        'token': token,
        'sessionid': sessionid
      }
      var data = this.common.encryptionData(dataJson, this)
      console.log(data)
      getTripTime(data).then(res => {
        console.log(res)
        if (res.flag === '200') {
          var orderstatus = res.data.order_status
          if (this.orderstatus !== orderstatus) {
            this.getDetail()
          }
        }
      })
    },
    // doModifyOrderStatus () {
    //   var orderno = this.$route.query.orderno
    //   if (orderno === undefined) {
    //     this.detail = []
    //     return false
    //   }
    //   var time = parseInt(new Date().getTime() / 1000)
    //   var token = localStorage.getItem('token')
    //   var dataJson = {
    //     'orderno': orderno,
    //     'old_order_status': this.orderstatus,
    //     'order_status': 4, // 取消订单
    //     'time': time,
    //     'token': token
    //   }
    //   var data = this.common.encryptionData(dataJson, this)
    //   console.log(data)
    //   modifyOrderStatus(data).then(res => {
    //     console.log(res)
    //     if (res.flag === '001') {
    //       this.$router.push({name: 'login'})
    //     } else {
    //       this.getDetail()
    //     }
    //   })
    // },
    formatNum (num) {
      return num < 10 ? '0' + num : '' + num
    },
    jumpDetail (hotelid, hotelname) {
      if (this.source === 'roompai' && hotelid !== '' && hotelid !== null && hotelid !== undefined) {
        var date1 = new Date()
        date1.setDate(date1.getDate() + 1)
        var date2 = new Date(date1)
        date2.setDate(date1.getDate() + 1)
        var start = (date1.getFullYear()) + '-' + (date1.getMonth() + 1) + '-' + (date1.getDate())
        var end = (date2.getFullYear()) + '-' + (date2.getMonth() + 1) + '-' + (date2.getDate())
        this.$router.push({name: 'HotelDetail', query: {'hotelid': hotelid, 'region': hotelname, 'start_date': start, 'end_date': end, 'room': 1, 'adult': 2, 'child': 0, 'language': this.language, 'currency': this.currency, 'source': this.source}})
      }
    }
  }
}
</script>

<style scoped>
/* 左侧 menu*/
.el-main{text-align: left;margin: 1%;}
.main{width:100%;}

/* 酒店详情 */
/deep/ .el-collapse-item__header, .el-collapse, /deep/ .el-collapse-item__wrap{border: none; background-color: #f8f9fa;}
.list-content /deep/ .el-collapse-item__arrow{ display: none;}
.back-button{height: 20px;line-height: 20px;}
.back-img{width: 15px; height: 15px; margin: 2.5px; float: left;}
.hotel-info{clear: both; height:auto; background-color: #FFF; margin-top: 15px; padding: 10px 1.5%;border-radius: 5px; }
.hotel-name{width:70%; height: 32px; line-height: 32px;font-size: 28px; font-weight: 650; color:rgba(83, 102, 163, 1); margin-bottom: 10px;}
.hotel-contact-info{font-size: 12px; margin-top: 15px; height: 15px;line-height: 15px;}
.hotel-contact-info img{height:15px;}
.hotel-contact-info div{display: inline-block; float: left;}
.points-hotel-info{background-color: #FFF; margin-top: 15px; padding:20px 1.5% 10px 1.5%;border-radius: 5px;}
.points-hotel-name{height: 40px; line-height: 40px; color:rgb(83, 102, 163); font-size: 14px;}
.quarter-row-title,
.quarter-row{
  display: grid;
  font-size: 14px;
  line-height: 40px;
  height: 40px;
  grid-template-columns: repeat(3, 1fr);
}
.quarter-row-title {
  background: #D9D9D940;
  font-weight: 500;
}
.quarter-row {
  font-weight: 400;
}
.quarter-col {
  text-align: left;
  color: #333;
  padding-left: 20px;
}
.points-txt {
  margin-top: 6px;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #86909C;
}

/* 订单详情 */
.tag-order-status{font-weight: 500;font-style: normal;font-size: 12px;padding: 3px; margin-left: 10px;}
.tag-confirm{color: #67C23A;background:#EEF9E9;}
.tag-noconfirm{color: #EBB563;background:#FFF6EC;}
.tag-cancel{color: #66B1FF;background:#E9F5FF;}
.tag-payment{color: #F78989;background:#FFEFF0;}
.line-info{border-bottom: 1.5px solid rgba(83, 102, 163, 1);float: none;width: 100%;clear:both;}
.line-info-two{border-bottom: 0.8px solid rgba(83, 102, 163, 1);float: none;width: 100%;}
.first-line{ height: 35px; line-height: 35px; width: 100%;}
.first-line div, .order-item div, .notes-item div{display: inline-block; float: left;}
.title{ font-size: 14px; font-weight: 650; color: rgba(83, 102, 163, 1); width: 12%;}
.title-left{ font-size: 14px; font-weight: 650; color: rgba(83, 102, 163, 1); width: 60%; float: left;}
.title-right{ font-size: 14px; font-weight: 650; color: rgba(83, 102, 163, 1); width: 40%; float: right;}
.info{font-size: 14px; color: #0E6489; width: 88%;}
.order-item{height: 35px; line-height: 35px; width: 100%; font-size: 14px; clear: both;}
.left-info{ width: 25%; font-weight: 500;}
.right-info{width: 75%;}
.price-info{font-size: 14px; height: auto; line-height: 40px;}
.price-left{width: 60%; float: left;}
.price-right{width: 40%; float: left;}
.price-left div, .price-right div{display: inline-block; text-align: left;}
.price-line{width: 100%; min-height: 40px; clear: both;}
.price-info-left{ width: 63%; font-weight: 500; float: left;}
.price-info-right{ width: 35%; float: left; text-align: right ;}
.float-right{text-align: right !important;}
.avgprice{ display: block !important;color: #616161; font-size: 12px; line-height: 12px;margin-top: -10px;}
/* 日志 */
.notes-item{line-height: 25px; width: 100%; font-size: 14px; clear: both; min-height: 25px; overflow: auto; margin-bottom: 10px;}
.notes-margin{ margin-top: 10px;}
/* 新版订单详情 */
.left-price{background-color: #FFF;margin-top: 15px; padding:10px 1.5%; border-radius: 5px; width: 46.5%; float: left;}
.right-price{background-color: #FFF;margin-top: 15px; padding:10px 1.5%; border-radius: 5px; width: 46.5%; float: right;}
.title-price{font-size: 14px; font-weight: 650; color: rgba(83, 102, 163, 1);}
.price-info-item{width: 100%; height: auto; display: flow-root;}
.blod-text{font-size: 16px; font-weight: 500;}
/* 按钮 */
.button-info{width: 100%; height: 100px; text-align: center; margin-top: 40px; clear: both;}
.float-none{float: none !important; margin-top: 12.5px !important;}
.display-button{cursor:no-drop; width: 140px; height: 40px; font-size: 14px; font-weight: 400; background: #909399;color: #FFF; border: 1px solid #909399; border-radius: 5px; vertical-align: top;}

/* 取消弹框 */
.dia-content{ padding: 20px 0px;border-bottom: 1px solid #EEEEEE;margin: 0 5%;}
.open-dia /deep/ .el-button+.el-button{margin-left:0px;}
.open-dia /deep/ .el-button:hover{color:#FFF;background: rgba(41, 111, 247, 1);border: 1px solid rgba(41, 111, 247, 1);}
.open-dia /deep/ .el-dialog{border-radius: 12px;}
.open-dia /deep/ .el-dialog__body{padding:0px;color:#333333;}
.open-dia /deep/ .el-dialog__header{padding: 20px 0px;margin: 0 5%;height: 20px; font-size: 22px; font-weight: 650; line-height: 20px; border-bottom: 1px solid #EEEEEE;}
/deep/ .el-select .el-input__inner:focus, .el-select .el-input.is-focus .el-input__inner,.el-range-editor.is-active, .el-range-editor.is-active:hover, .el-select .el-input.is-focus .el-input__inner, /deep/ .el-input.is-active .el-input__inner, /deep/ .el-input__inner:focus{border-color:rgba(83, 102, 163, 1) !important;box-shadow:0px 0px 8px rgba(83, 102, 163, 1);}
/deep/ .el-select-dropdown__item.selected{color: rgba(83, 102, 163, 1) !important;}
/deep/ .el-dialog__footer{padding: 20px 5%;}
/deep/ .el-dialog__headerbtn .el-dialog__close{color: rgba(83, 102, 163, 1);font-weight: 650;}
.codeError,.codeError:focus,.codeError:hover{background: inherit;background-color: rgba(255, 255, 255, 1);box-sizing: border-box;border: 2px solid rgba(225, 45, 45, 1);border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;}

/* 住房须知 */
.hotelFeesText /deep/ p{margin-block-start: 5px;margin-block-end: 5px;}
.hotelFeesText /deep/ ul{margin-left:20px;margin-bottom: 10px;}
.room-order-tips-info{padding-bottom: 5px; height: auto;font-size: 14px;}

.pdfShow {color: rgba(83, 102, 163, 1); text-decoration: underline; float: right}
.pdfShow span {margin-right: 20px;cursor: pointer;}
/* 骨架屏 */
/deep/ .el-card.is-always-shadow, /deep/ .el-card.is-hover-shadow:focus, /deep/ .el-card.is-hover-shadow:hover{box-shadow: none;}

.hotel-policies-container {
  display: flex;
  flex-wrap: wrap;
  margin: 15px 0px;
  background: #fff;
  padding: 10px 1.5% 0px;
  border-radius: 5px;
}

.policy-block {
  width: 49%;
  margin: 10px 10px 20px 0px;
}

.policy-block h3 {
  margin: 0 0 10px 0;
  font-size: 16px;
}

.policy-block .policy-content {
  font-size: 14px;
  line-height: 1.5;
  font-weight: 400;
}

.check-info-container {
  display: flex;
  justify-content: space-between;
}

.check-info-block {
  width: 48%;
}

.check-info-title {
  color: #4E7997;
  font-size: 14px;
  margin-bottom: 10px;
}

.check-info-content p {
  margin: 8px 0;
  line-height: 1.5;
}

.policy-block .policy-content p {
  margin: 5px 0;
}

.policy-block .policy-content ul {
  margin: 5px 0;
  padding-left: 20px;
}

.price-hotel-info{
  background-color: #FFF;
  margin-top: 15px;
  padding:20px 1.5% 10px 1.5%;
  border-radius: 5px;
  display: flex;                /* 添加 flex 布局 */
  justify-content: space-between; /* 两端对齐 */
  align-items: stretch;      /* 顶部对齐 */
}

.price-hotel-info-left {
    width: 64%;
    border: 1px solid #e8e8e8;
    padding: 10px;
    border-radius: 5px;
}

.price-hotel-info-right {
    width: 34%;
    border: 1px solid #e8e8e8;
    padding: 10px;
    border-radius: 5px;
    margin-left: 15px;
    display: flex; /* 新增 */
    flex-direction: column; /* 新增 */
}

.price-details-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  color: #666;
}

.package-hotel-name{
  height: 40px;
  line-height: 40px;
  color:rgb(83, 102, 163);
  font-size: 14px;
}

.package-tag {
  background: #F6FFED;
  color: #52C41A;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  border: 1px solid #B7EB8F
}

.price-sections-container {
  display: flex;
  gap: 29px;
  margin-bottom: 20px;
  align-items: stretch;
  flex-grow: 1;
}

.price-section {
  flex: 1;
  background: #5366A30F;
  border-radius: 8px;
  padding: 16px 20px;
  display: flex; /* 新增：使内部元素可以使用flex布局 */
  flex-direction: column; /* 新增：使内部元素垂直排列 */
  flex-grow: 1;
}

.price-box {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex-grow: 1;
}

.section-title {
  color: #5366A3;
  font-size: 14px;
  margin-bottom: 10px;
  font-weight: 700;
}

.price-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex-grow: 1; /* 新增：使其填充可用空间，并将totals推到底部 */
}

.price-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: #333;
}

.price-item span {
  display: flex;
  align-items: center;
}

.avgprice{
  color: #616161;
  font-size: 12px;
  line-height: 12px;
  margin-left: 4px;
  margin-top: 3px;
}

.green-text {
    color: #2F7000;
}

.divider {
  height: 1px;
  background: #000000;
  margin-top: auto; /* 新增：将分隔线和总计部分推向底部 */
}

.price-item.total {
  font-weight: 600;
}

.total-price {
  display: flex;
  justify-content: justify;
  align-items: center;
  padding-top: 16px;
  border-top: 1px solid #e8e8e8;
  font-size: 16px;
  font-weight: 600;
}

.total-price .amount {
  color: #2b3481;
  font-size: 20px;
  margin-left: 5px;
}

.container {
    margin-top: 15px;
    background-color: #ffffff;
    padding: 15px 1%;
    border-radius: 4px;
    line-height: 1.5;
}

.container h1 {
    text-align: left;
    color: rgb(83, 102, 163);
    font-size: 16px;
    font-weight: 600;
    border-bottom: 1px solid #eee;
    padding-bottom: 15px;
}

/* 政策列布局 */
.policy-columns {
    display: flex;
    /* 允许列在需要时换行，虽然对于两列来说不那么关键 */
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 20px;
}

.policy-column {
    flex: 1 1 45%;
    min-width: 300px; /* 确保在小屏幕下换行前有一个最小宽度 */
}

/* CSS规则：用于隐藏空的列 (这需要通过 JS 或模板逻辑来添加 `.empty` 类) */
.policy-column.empty {
    display: none; /* 如果列为空，则完全隐藏该列 */
}

/* 政策模块样式 */
.policy-module {
    background-color: #ffffff;
    border-radius: 4px;
    padding: 15px 20px;
    margin-bottom: 20px;
}

/* 移除每列中最后一个模块的底部外边距，使布局更紧凑 */
.policy-module:last-child {
    margin-bottom: 0;
}

.policy-module h2 {
    color: #333;
    font-size: 14px;
    font-weight: 600;
    margin-top: 0;
    margin-bottom: 15px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e0e0e0;
    padding-left: 0;
}

/deep/ .policy-module ul {
    list-style: none;
    padding-left: 0;
    margin: 0;
}

/deep/ .policy-module li {
    position: relative;
    margin-bottom: 8px;
    padding-left: 0; /* 如果不使用自定义项目符号，则无需内边距 */
    font-size: 13px;
    color: #555;
}

.policy-module-text {
    position: relative;
    margin-bottom: 8px; /* Adjusted: Slightly reduced list item spacing */
    padding-left: 0; /* Adjusted: Removed padding for custom bullet if not needed */
    font-size: 13px; /* Adjusted: Slightly smaller font size */
    color: #555;
}

.policy-module div {
  font-size: 14px;
}

.policy-content >>> li {
  list-style-type: disc;
  margin-left: 20px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .policy-columns {
        flex-direction: column;
        gap: 20px;
    }
    .policy-column {
        min-width: 100%;
    }
    .policy-module {
        padding: 15px; /* Adjust padding for smaller screens if needed */
    }
}

/* 取消政策弹框样式 */
.cancel-policy {
  background: #fff;
  padding: 12px;
  /* max-height: 150px; */
  overflow-y: auto;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.content-item {
  display: flex;
  align-items: flex-start;
  background: #fff;
}

.cancel-policy .title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
  width: 100%;
}

.cancel-policy .circle {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  border: 2px solid #cc0000; /* 修改为边框 */
  background: transparent; /* 背景设置为透明 */
  margin-top: 6px;
  margin-right: 8px;
  flex-shrink: 0;
}

.cancel-policy .text-content {
  flex: 1;
}

.cancel-policy .subtitle {
  font-size: 13px;
  color: #333;
  margin-bottom: 4px;
  font-weight: 500;
}

.cancel-policy .description {
  font-size: 12px;
  color: #666;
  line-height: 1.4;
}

/* 弹框容器样式 */
.nonFefundable {
  background: #fff !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  max-height: 180px !important;
  height: auto !important;
}

/deep/ .el-dialog {
  margin-top: 30vh !important;
}

/deep/ .facilities-dialog .el-dialog__body{
  padding: 0px 20px 30px;
}

.facilities-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.facilities-list li {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 14px;
}

.facilities-list li i {
  font-size: 18px;
  margin-right: 10px;
  color: #6c5ce7;
}

.dialog-footer .el-button {
  border-radius: 5px;
}

/* You might need to adjust icon colors if they don't match exactly */
.facilities-list li .el-icon-present,
.facilities-list li .el-icon-time,
.facilities-list li .el-icon-magic-stick {
    color: #20c997;
}

.facilities-divider {
    width: 100%;
    height: 1px;
    background: #e5e6eb;
    margin-bottom: 15px;
    border: none;
  }

.arrow-icon {
  margin-right: 10px; /* 箭头与文字的间距 */
  color: #5366a3; /* 箭头颜色，可以根据品牌色调整 */
  font-size: 0.9em; /* 调整箭头大小 */
}
</style>
<style>
.el-tooltip__popper.is-light {
  max-width: 300px !important;
  white-space: normal !important;
  word-wrap: break-word !important;
  line-height: 1.5 !important;
  padding: 8px 12px !important;
  background: #999999 !important;
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/account/tripDetail.vue